export default __webpack_public_path__ + "static/media/sc29.7fac1799.jpg";